import { observable, action, makeObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export class CareNavigatorStore {
  group_id: string = '';
  group_name: string = '';
  eg_nid: string = '';
  existing: boolean = true;

  constructor() {
    makeObservable(this, {
      group_id: observable,
      group_name: observable,
      eg_nid: observable,
      existing: observable,
      setGroupData: action,
      removeGroupData: action,
    });

    makePersistable(this, {
      name: 'CareNavigatorStore',
      properties: [
        'group_name',
        'group_id',
        'eg_nid',
        'existing'
      ],
      storage: window.localStorage,
    });
  }

  setGroupData(
    group_id: string,
    group_name: string,
    eg_nid: string,
    existing: boolean
  ) {
    this.group_id = group_id;
    this.group_name = group_name;
    this.eg_nid = eg_nid;
    this.existing = existing;
  }

  removeGroupData() {
    this.group_id = '';
    this.group_name = '';
    this.eg_nid = '';
    this.existing = true;
  }
}
export default CareNavigatorStore;
